/* Image strip on bundle cards.

   The bundle builder keeps the shopper on one page, so a card is the only
   view of a frame they get — and it showed the first photo only. Every
   image the product page would show is now on the card: swipe on a phone,
   arrows on hover on a desktop, with a counter.

   The card's own tap still picks the frame. The arrows stop the event, so
   browsing photos never adds something to a bundle by accident.

   THE ARROWS ARE NOT CLIPPED, and that took three goes:
     - .bshell carried overflow:hidden, which could cut the circles against
       the tile edge. The strip clips its own images, so the shell does not
       need it at all.
     - The tile has 5px of padding and absolute positioning is measured
       from the padding box, so a small inset put the circle over the tile
       border. They now sit 14px in, clear of it on any width.
     - A shadow and a solid white fill keep them readable over a photo
       rather than relying on the tint behind.

   THE ARROWS ANIMATE THE SCROLL THEMSELVES. Two native routes failed:
   scrollBy({behavior:'smooth'}) is cancelled by scroll-snap-type mandatory,
   and CSS scroll-behavior:smooth is cancelled when a lazy image further
   along finishes loading and shifts layout. Both looked like a dead arrow.
   The tween carries a deadline because requestAnimationFrame pauses in a
   background tab, which would otherwise strand the strip between photos. */
(function(){
"use strict";
var CSS=
 '.bshell{position:relative}'+
 '.bstrip{display:flex;width:100%;height:100%;overflow-x:auto;scroll-snap-type:x mandatory;'+
   '-webkit-overflow-scrolling:touch;scrollbar-width:none;cursor:pointer}'+
 '.bstrip.sliding{scroll-snap-type:none}'+
 '.bstrip::-webkit-scrollbar{display:none}'+
 '.bstrip img{flex:0 0 100%;width:100%;height:100%;object-fit:contain;'+
   'scroll-snap-align:start;pointer-events:none}'+
 '.bnav{position:absolute;top:50%;margin-top:-14px;z-index:4;width:28px;height:28px;'+
   'border-radius:50%;border:0;background:#fff;box-shadow:0 1px 4px rgba(20,26,25,.18);'+
   'color:#141a19;font-size:15px;line-height:28px;text-align:center;cursor:pointer;'+
   'opacity:0;transition:opacity .15s;padding:0}'+
 '.bshell:hover .bnav{opacity:1}'+
 '.bnav:focus-visible{opacity:1}'+
 '.bnav.p{left:14px}.bnav.n{right:14px}'+
 '.bcount{position:absolute;right:12px;bottom:12px;z-index:4;font-size:10px;letter-spacing:.06em;'+
   'background:rgba(255,255,255,.92);border-radius:999px;padding:3px 8px;color:#5d6564;pointer-events:none}'+
 '@media (hover:none){.bnav{display:none}}';

function inject(){
  var s=document.getElementById('sf-bimg-css');
  if(!s){ s=document.createElement('style'); s.id='sf-bimg-css'; document.head.appendChild(s) }
  if(s.textContent!==CSS) s.textContent=CSS;
}
function count(strip){
  var tag=strip.parentNode.querySelector('.bcount'); if(!tag) return;
  var n=strip.querySelectorAll('img').length;
  var i=Math.round(strip.scrollLeft/Math.max(1,strip.clientWidth))+1;
  tag.textContent=Math.min(Math.max(i,1),n)+' / '+n;
}
function land(strip, to){
  strip.scrollLeft=to;
  strip.classList.remove('sliding');
  count(strip);
}
function tween(strip, to){
  var from=strip.scrollLeft, d=to-from, t0=null, ms=240, done=false;
  if(d===0){ land(strip,to); return }
  strip.classList.add('sliding');
  var deadline=setTimeout(function(){ if(!done){ done=true; land(strip,to) } }, ms+260);
  function step(ts){
    if(done) return;
    if(t0===null) t0=ts;
    var k=Math.min(1,(ts-t0)/ms);
    var e = k<0.5 ? 2*k*k : 1-Math.pow(-2*k+2,2)/2;
    strip.scrollLeft = from + d*e;
    if(k<1){ requestAnimationFrame(step) }
    else { done=true; clearTimeout(deadline); land(strip,to) }
  }
  requestAnimationFrame(step);
}

window.SFSlide=function(btn, dir, ev){
  if(ev && ev.stopPropagation) ev.stopPropagation();
  var shell=btn.parentNode, strip=shell.querySelector('.bstrip');
  if(!strip) return;
  var w=strip.clientWidth || 1;
  var max=Math.max(0, strip.scrollWidth - w);
  var next=Math.round(strip.scrollLeft/w)*w + dir*w;
  if(next<0) next=max;
  if(next>max) next=0;
  tween(strip, next);
};

function watch(strip){
  if(strip.dataset.watched) return;
  strip.dataset.watched='1';
  var t=null;
  strip.addEventListener('scroll', function(){
    if(strip.classList.contains('sliding')) return;
    clearTimeout(t); t=setTimeout(function(){ count(strip) }, 60);
  }, {passive:true});
}
function scan(){
  inject();
  var grid=document.getElementById('bGrid'); if(!grid) return;
  [].slice.call(grid.querySelectorAll('.bstrip')).forEach(watch);
}

document.addEventListener('DOMContentLoaded', function(){
  var grid=document.getElementById('bGrid'); if(!grid) return;
  inject(); scan();
  new MutationObserver(function(){ scan() }).observe(grid,{childList:true});
});
})();